module.exports = __webpack_public_path__ + "static/media/cvc-empty.0230b49a.svg";